import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  addDoc, collection, deleteDoc, doc, getDocs,
  orderBy, query, serverTimestamp, updateDoc
} from "firebase/firestore";
import ImageUploader from "../../components/ImageUploader";

const CATEGORIES = [
  "Consommables","Mobilier","Imagerie","Laboratoire","Équipements","EPI","Pesage"
];

export default function ProductsAdmin() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({
    title: "", ref: "", department: "medical", category: "Consommables",
    desc: "", imageUrl: ""
  });

  const load = async () => {
    setLoading(true);
    const snap = await getDocs(query(collection(db, "products"), orderBy("createdAt","desc")));
    setList(snap.docs.map(d => ({ id:d.id, ...d.data() })));
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const onChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    if (editing) {
      await updateDoc(doc(db, "products", editing), { ...form });
    } else {
      await addDoc(collection(db, "products"), { ...form, createdAt: serverTimestamp() });
    }
    setForm({ title:"", ref:"", department:"medical", category:"Consommables", desc:"", imageUrl:"" });
    setEditing(null);
    load();
  };

  const edit = (it) => {
    setEditing(it.id);
    setForm({
      title: it.title || "", ref: it.ref || "", department: it.department || "medical",
      category: it.category || "Consommables", desc: it.desc || "", imageUrl: it.imageUrl || ""
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const del = async (id) => {
    if (!window.confirm("Supprimer ce produit ?")) return;
    await deleteDoc(doc(db,"products", id));
    load();
  };

  return (
    <div>
      <h3 className="fw-bold mb-3">Produits</h3>

      {/* FORM */}
      <form onSubmit={save} className="card card-body shadow-sm mb-4">
        <div className="row g-3">
          <div className="col-md-7">
            <label className="form-label">Titre</label>
            <input name="title" className="form-control" value={form.title} onChange={onChange} required />
          </div>
          <div className="col-md-5">
            <label className="form-label">Référence</label>
            <input name="ref" className="form-control" value={form.ref} onChange={onChange} placeholder="EX: EDTA-100" />
          </div>
          <div className="col-md-4">
            <label className="form-label">Département</label>
            <select name="department" className="form-select" value={form.department} onChange={onChange}>
              <option value="medical">Médical</option>
              <option value="industrial">Industriel</option>
            </select>
          </div>
          <div className="col-md-4">
            <label className="form-label">Catégorie</label>
            <select name="category" className="form-select" value={form.category} onChange={onChange}>
              {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div className="col-md-4">
            <label className="form-label">Image (URL)</label>
            <input name="imageUrl" className="form-control" value={form.imageUrl} onChange={onChange} placeholder="https://…" />
          </div>
          <div className="col-12">
            <label className="form-label">Ou téléverser une image</label>
            <ImageUploader onUploaded={(url)=>setForm(f=>({...f, imageUrl:url}))} pathPrefix="uploads/products" />
          </div>
          <div className="col-12">
            <label className="form-label">Description</label>
            <textarea name="desc" rows={3} className="form-control" value={form.desc} onChange={onChange} />
          </div>
        </div>
        <div className="mt-3 d-flex gap-2">
          <button className="btn btn-success">{editing ? "Mettre à jour" : "Publier le produit"}</button>
          {editing && <button type="button" className="btn btn-outline-secondary" onClick={()=>{setEditing(null); setForm({title:"",ref:"",department:"medical",category:"Consommables",desc:"",imageUrl:""});}}>Annuler</button>}
        </div>
      </form>

      {/* LIST */}
      {loading ? (
        <div className="alert alert-light border">Chargement…</div>
      ) : (
        <div className="row g-3">
          {list.map(it => (
            <div key={it.id} className="col-12 col-md-6 col-lg-4">
              <div className="card h-100 shadow-sm">
                {it.imageUrl ? <img src={it.imageUrl} className="card-img-top" alt={it.title} style={{ height:280, objectFit:"contain" }} /> : <div className="bg-light" style={{ height:180 }} />}
                <div className="card-body d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-start">
                    <span className={"badge " + (it.department==="medical" ? "bg-success" : "bg-secondary")}>
                      {it.department==="medical" ? "Médical" : "Industriel"}
                    </span>
                    <small className="text-muted">Réf. {it.ref || "-"}</small>
                  </div>
                  <h6 className="mt-2">{it.title}</h6>
                  <p className="small text-muted">{it.category} — {it.desc?.slice(0,90)}</p>
                  <div className="mt-auto d-flex gap-2">
                    <button className="btn btn-sm btn-outline-primary" onClick={()=>edit(it)}>Éditer</button>
                    <button className="btn btn-sm btn-outline-danger" onClick={()=>del(it.id)}>Supprimer</button>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {list.length===0 && <div className="col-12"><div className="alert alert-info">Aucun produit.</div></div>}
        </div>
      )}
    </div>
  );
}
